// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"89a60002","304":"b403eba1","360":"31b2514f","453":"cec3e1db","510":"2b48e51b","511":"33c52e47","617":"04998ad1","640":"7be4fe43","778":"12adb860","858":"cd269ccf","984":"f4aec6ae"}[chunkId] + ".chunk.js";
};